import { colorCSS } from "../../../styles";

export const TextIcon = () => {
    return (
        <svg height="10" viewBox="0 0 16 10" width="16">
            <path
                d="m1 0h14c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-14c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1zm0 4h14c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-14c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1zm0 4h8c.55228475 0 1 .44771525 1 1s-.44771525 1-1 1h-8c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1z"
                fill={colorCSS("N500", 0.3)}
                fillRule="evenodd"
            />
        </svg>
    );
};
